import memoizeOne from 'memoize-one';
import React, { PureComponent } from 'react';
import parseHumanFloat from '~/libs/Number/parseHumanFloat';
import { isValidPackageSize } from '~/Product';
import inputCompactStyles from '~/UI/Input/compact.less';
import Input from '~/UI/Input/Input';

import styles from './styles.less';

interface Props {
	value: number | null;
	onChange(a: string): void;
	onCommit(a: number | null): void;
}

interface State {
	value: string | null;
}

export default class PackageSizeInput extends PureComponent<Props, State> {
	state = {
		value: null,
	};

	timeoutId: NodeJS.Timeout | null = null;

	componentWillUnmount() {
		if (this.timeoutId !== null) {
			clearTimeout(this.timeoutId);
			this.commit();
		}
	}

	render() {
		const { value, parsedValue } = this;

		return (
			<div className={styles.packageInput}>
				<Input
					isInvalid={parsedValue === null && value !== ''}
					styles={inputCompactStyles}
					value={value}
					onBlur={this.blurred}
					onChange={this.changed}
				/>
			</div>
		);
	}

	get value(): string {
		const { value } = this.state;

		if (value !== null) {
			return value;
		}

		return this.props.value !== null ? String(this.props.value) : '';
	}

	get parsedValue(): number | null {
		return this.parseValue(this.value);
	}

	parseValue = memoizeOne((value: string): number | null => {
		if (value === '') {
			return null;
		}
		const parsedValue = parseHumanFloat(value);
		return parsedValue !== null && isValidPackageSize(parsedValue) ? parsedValue : null;
	});

	changed = (event: React.FormEvent<HTMLInputElement>) => {
		const { value } = event.currentTarget;
		this.setState({ value });

		if (value !== '' && this.parseValue(value) === null) {
			return;
		}

		this.props.onChange(value);
		if (this.timeoutId !== null) {
			clearTimeout(this.timeoutId);
		}
		this.timeoutId = setTimeout(this.commit, 2000);
	};

	blurred = () => {
		if (this.timeoutId !== null) {
			clearTimeout(this.timeoutId);
			this.timeoutId = null;
			this.commit();
		}
	};

	commit = () => {
		const {
			props: { onCommit },
			parsedValue,
		} = this;
		onCommit(parsedValue);
	};
}
